/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_Every_HintInputs */

const en_us2_profile_editors_reminder_every_hint = /** @type {(inputs: Profile_Editors_Reminder_Every_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includes a light reminder on rest days`)
};

const pt_br2_profile_editors_reminder_every_hint = /** @type {(inputs: Profile_Editors_Reminder_Every_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclui um lembrete leve nos dias de descanso`)
};

const es_419_profile_editors_reminder_every_hint = /** @type {(inputs: Profile_Editors_Reminder_Every_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluye un recordatorio suave los días de descanso`)
};

const pt_pt2_profile_editors_reminder_every_hint = /** @type {(inputs: Profile_Editors_Reminder_Every_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclui um lembrete leve nos dias de descanso`)
};

const fr_fr2_profile_editors_reminder_every_hint = /** @type {(inputs: Profile_Editors_Reminder_Every_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec un rappel léger les jours de repos`)
};

const de_de2_profile_editors_reminder_every_hint = /** @type {(inputs: Profile_Editors_Reminder_Every_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit einer sanften Erinnerung an Ruhetagen`)
};

const it_it2_profile_editors_reminder_every_hint = /** @type {(inputs: Profile_Editors_Reminder_Every_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include un promemoria leggero nei giorni di riposo`)
};

/**
* | output |
* | --- |
* | "Includes a light reminder on rest days" |
*
* @param {Profile_Editors_Reminder_Every_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_every_hint = /** @type {((inputs?: Profile_Editors_Reminder_Every_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_Every_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_every_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_every_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_every_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_every_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_every_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_every_hint(inputs)
	return en_us2_profile_editors_reminder_every_hint(inputs)
});
export { profile_editors_reminder_every_hint as "profile-editors.reminder_every_hint" }